var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUiWebpageSlider = function SvgUiWebpageSlider(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1155 28.125H10.125C9.52826 28.125 8.95597 27.8879 8.53401 27.466C8.11205 27.044 7.875 26.4717 7.875 25.875V3.375C7.875 2.77826 8.11205 2.20597 8.53401 1.78401C8.95597 1.36205 9.52826 1.125 10.125 1.125H25.875C26.4717 1.125 27.044 1.36205 27.466 1.78401C27.8879 2.20597 28.125 2.77826 28.125 3.375V20.184",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 25.875H3.375C2.77826 25.875 2.20597 25.6379 1.78401 25.216C1.36205 24.794 1.125 24.2217 1.125 23.625V5.625C1.125 5.02826 1.36205 4.45597 1.78401 4.03401C2.20597 3.61205 2.77826 3.375 3.375 3.375H7.875",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 3.375H32.625C33.2217 3.375 33.794 3.61205 34.216 4.03401C34.6379 4.45597 34.875 5.02826 34.875 5.625V23.625",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 6.75H23.625",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 12.375H23.625",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 18H16.875",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5342 24.5339L28.5107 34.8749L30.8972 30.8969L34.8752 28.5104L24.5342 24.5339Z",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.875 34.875L30.897 30.897",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUiWebpageSlider, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ui-webpage-slider.c43668b2.svg";
export { ForwardRef as ReactComponent };